// Small line icons (24×24, stroked) and the quiet icon button used everywhere.
const ICONS = {
  image: 'M4 5h16v14H4zM8.5 10a1.5 1.5 0 1 0 0-.01M20 16l-5-5-8 8',
  gallery: 'M3 7h13v12H3zM8 4h13v12',
  video: 'M3 6h13v12H3zM16 10l5-3v10l-5-3',
  youtube: 'M3 7q0-2 2-2h14q2 0 2 2v10q0 2-2 2H5q-2 0-2-2zM10 9v6l5-3z',
  tweet: 'M4 5h16v11H9l-5 4z',
  table: 'M3 5h18v14H3zM3 10h18M3 15h18M10 5v14',
  details: 'M4 6l3 3-3 3M10 9h10M4 15h16M4 19h12',
  math: 'M18 5H6l6 7-6 7h12',
  html: 'M8 7l-5 5 5 5M16 7l5 5-5 5M14 4l-4 16',
  bullet: 'M9 6h12M9 12h12M9 18h12M4 6h.01M4 12h.01M4 18h.01',
  ordered: 'M10 6h11M10 12h11M10 18h11M4 4v4M3 18h3l-3 3h3',
  quote: 'M6 17q-3 0-3-4t5-6M16 17q-3 0-3-4t5-6',
  link: 'M10 14a4 4 0 0 0 5.7 0l3-3a4 4 0 0 0-5.7-5.7l-1 1M14 10a4 4 0 0 0-5.7 0l-3 3a4 4 0 0 0 5.7 5.7l1-1',
  unlink:
    'M10 14a4 4 0 0 0 5.7 0l3-3a4 4 0 0 0-5.7-5.7l-1 1M14 10a4 4 0 0 0-5.7 0l-3 3a4 4 0 0 0 5.7 5.7l1-1M3 3l18 18',
  open: 'M14 4h6v6M20 4l-9 9M18 14v6H4V6h6',
  footnote: 'M4 18h10M4 13h16M4 8h16M18 3v4M16.5 4.5h3',
  trash: 'M4 7h16M10 11v6M14 11v6M6 7l1 13h10l1-13M9 7V4h6v3',
  cite: 'M4 6h16M4 11h16M8 17h12M4 17h1',
  caption: 'M4 4h16v11H4zM4 19h16',
  rowAdd: 'M3 4h18v7H3zM12 15v6M9 18h6',
  rowDel: 'M3 4h18v7H3zM9 18h6',
  colAdd: 'M4 3h7v18H4zM18 9v6M15 12h6',
  colDel: 'M4 3h7v18H4zM15 12h6',
  header: 'M3 5h18v14H3zM3 10h18M3 5h18v5H3z',
  imageAdd: 'M4 5h10M4 5v14h16v-6M8.5 10a1.5 1.5 0 1 0 0-.01M20 16l-5-5-8 8M19 3v6M16 6h6',
  upload: 'M12 16V4M7 9l5-5 5 5M4 16v4h16v-4',
  close: 'M6 6l12 12M18 6L6 18',
  unpublish: 'M3 12q4-7 9-7t9 7q-4 7-9 7t-9-7zM12 9.5a2.5 2.5 0 1 0 0 5a2.5 2.5 0 1 0 0-5M4 4l16 16',
  settings: 'M4 6h9M17 6h3M4 12h3M11 12h9M4 18h11M19 18h1M15 4v4M9 10v4M17 16v4',
};

export const Icon = ({ name }) => (
  <svg
    viewBox="0 0 24 24"
    width="18"
    height="18"
    fill="none"
    stroke="currentColor"
    stroke-width="1.8"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
  >
    <path d={ICONS[name]} />
  </svg>
);

// An icon button that does not take focus from the editor.
export const IconButton = ({ icon, title, active, run, children, class: cls = '' }) => (
  <button
    type="button"
    class={'ib ' + cls + (active ? ' on' : '')}
    title={title}
    aria-label={title}
    onMouseDown={(e) => (e.preventDefault(), run())}
    // the action ran on mousedown; the click must not reach a link or form around the button
    onClick={(e) => (e.preventDefault(), e.stopPropagation())}
  >
    {icon && <Icon name={icon} />}
    {children}
  </button>
);
